import React from 'react'
import Header from '../components/Header';
import Footer from '../components/Footer';
import ContactUsSection from '../components/ContactUsSection';

function ContactPage() {
  return (
    <div className="bg-white text-black">
      <Header />
      <main className="p-8">
      <ContactUsSection/>
      </main>
      <Footer />
    </div>
  );
}

export default ContactPage